<div class="dual-board-layout">
  <div class="dual-board-panel">
    <app-depatureboard [config]="config1" [allowNarrowAspect]="false"></app-depatureboard>
  </div>
  <div class="dual-board-panel">
    <app-depatureboard [config]="config2" [allowNarrowAspect]="false"></app-depatureboard>
  </div>
  <div class="dual-board-panel dual-board-empty"></div>
  <div class="dual-board-panel dual-board-empty"></div>
</div>
